import { render, staticRenderFns } from "./currency-flag-default.vue?vue&type=template&id=72be0132"
import script from "./currency-flag-default.ts?vue&type=script&lang=ts&external"
export * from "./currency-flag-default.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports